import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeader } from '../components/SectionHeader';
import { AnimatedCounter } from '../components/AnimatedCounter';
import { GlowOrb } from '../components/GlowOrb';
import { testimonials } from '../data/content';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Chakra Healing', 'Astrology', 'Energy Therapy', 'Coaching'];
  const filteredTestimonials = testimonials.filter(t => filter === 'All' ? true : t.category === filter);
  const featured = testimonials.find(t => t.featured) || testimonials[0];
  return <div className="pt-32 pb-24 relative min-h-screen overflow-hidden" data-id="element-943">
      <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
      backgroundImage: `url(https://images.unsplash.com/photo-1531123897727-8f129e1688ce?q=80&w=2000&auto=format&fit=crop)`
    }} data-id="element-944"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-midnight via-midnight/85 to-midnight" data-id="element-945"></div>
      <GlowOrb color="primary" size="xl" position="top-0 right-0" data-id="element-946" />
      <GlowOrb color="gold" size="lg" position="bottom-0 left-0" delay={2} data-id="element-947" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-948">
        <SectionHeader eyebrow="Soul Stories" title="Real Transformation" description="Hear from those who have walked the path of healing with Calmoras. Real stories of energetic shifts and life changes." data-id="element-949" />

        {/* Stats Banner */}
        <div className="glass rounded-[3rem] p-12 mb-24 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 divide-y md:divide-y-0 md:divide-x divide-white/10" data-id="element-950">
          <div className="text-center pt-8 md:pt-0" data-id="element-951">
            <div className="text-5xl font-serif text-white mb-2" data-id="element-952">
              <AnimatedCounter value={4.9} suffix="/5" data-id="element-953" />
            </div>
            <div className="text-xs text-gold uppercase tracking-widest font-bold" data-id="element-954">
              Average Rating
            </div>
          </div>
          <div className="text-center pt-8 md:pt-0" data-id="element-955">
            <div className="text-5xl font-serif text-white mb-2" data-id="element-956">
              <AnimatedCounter value={500} suffix="+" data-id="element-957" />
            </div>
            <div className="text-xs text-gold uppercase tracking-widest font-bold" data-id="element-958">
              5-Star Reviews
            </div>
          </div>
          <div className="text-center pt-8 md:pt-0" data-id="element-959">
            <div className="text-5xl font-serif text-white mb-2" data-id="element-960">
              <AnimatedCounter value={98} suffix="%" data-id="element-961" />
            </div>
            <div className="text-xs text-gold uppercase tracking-widest font-bold" data-id="element-962">
              Would Recommend
            </div>
          </div>
        </div>

        {/* Featured Testimonial */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} className="max-w-5xl mx-auto bg-gradient-to-br from-primary to-midnight-panel rounded-[3rem] p-10 md:p-20 mb-24 relative overflow-hidden border border-white/10 shadow-2xl" data-id="element-963">
          <div className="absolute inset-0 bg-star-dust opacity-30 mix-blend-screen" data-id="element-964"></div>
          <Quote className="absolute top-10 left-10 w-24 h-24 text-white/5" data-id="element-965" />

          <div className="relative z-10 text-center" data-id="element-966">
            <div className="flex justify-center text-gold mb-8" data-id="element-967">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-968" />)}
            </div>
            <p className="text-3xl md:text-5xl font-serif leading-tight mb-12 text-white" data-id="element-969">
              "{featured.quote}"
            </p>
            <div data-id="element-970">
              <p className="font-bold text-xl text-gold mb-2" data-id="element-971">
                {featured.name}
              </p>
              <p className="text-beige-muted uppercase tracking-widest text-xs font-bold" data-id="element-972">
                {featured.package} • {featured.sign}
              </p>
            </div>
          </div>
        </motion.div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-4 mb-16" data-id="element-973">
          {categories.map(cat => <button key={cat} onClick={() => setFilter(cat)} className={`relative px-6 py-2 text-sm font-medium transition-colors ${filter === cat ? 'text-white' : 'text-beige-muted hover:text-white'}`} data-id="element-974">
              {cat}
              {filter === cat && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-gold" data-id="element-975" />}
            </button>)}
        </div>

        {/* Grid */}
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-976">
          <AnimatePresence data-id="element-977">
            {filteredTestimonials.filter(t => !t.featured).map((testimonial, i) => <motion.div key={testimonial.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} className="glass p-10 rounded-[2rem] hover:border-gold/30 transition-colors" data-id="element-978">
                  <div className="flex justify-between items-start mb-8" data-id="element-979">
                    <div className="flex text-gold" data-id="element-980">
                      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-981" />)}
                    </div>
                    <span className="text-[10px] font-bold px-3 py-1 bg-white/5 text-gold rounded-full uppercase tracking-widest border border-white/10" data-id="element-982">
                      {testimonial.category}
                    </span>
                  </div>
                  <p className="text-beige leading-relaxed italic mb-8 text-lg" data-id="element-983">
                    "{testimonial.quote}"
                  </p>
                  <div data-id="element-984">
                    <p className="font-serif font-bold text-white text-xl mb-1" data-id="element-985">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-beige-muted uppercase tracking-wider" data-id="element-986">
                      {testimonial.location} • {testimonial.sign}
                    </p>
                  </div>
                </motion.div>)}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>;
}